import { render, staticRenderFns } from "./AppParameter.vue?vue&type=template&id=872bb3ac&"
import script from "./AppParameter.vue?vue&type=script&lang=js&"
export * from "./AppParameter.vue?vue&type=script&lang=js&"
import style0 from "./AppParameter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports